import { Component, ElementRef, ViewChild } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { BARCOLOR, DiagramDatas } from '../../diagram/diagram.component';

interface Result {
  result : Array<any>
}

@Component({
  selector: 'app-uebersicht',
  templateUrl: './uebersicht.component.html',
  styleUrls: ['./uebersicht.component.css']
})

export class UebersichtComponent {    
  
  uebersicht;
  
  diagramDatas : DiagramDatas;

  diagramDataInits : DiagramDatas = {
    height: 500,
    diagrams: []    
  };
  
  constructor( 
    private elementRef: ElementRef, 
    private api: ApiService 
  ) {     
    api.getUebersicht().then(( values ) => {
      this.uebersicht = values;
      
      this.diagramDataInits.diagrams.push({
        title: "Ver&shy;sorg&shy;ungs&shy;ziel",
        bars: [
          {
            value: this.uebersicht.versorgungszielEm,
            color: BARCOLOR.red,
            text: "Bei EM / BU / Unfall",
          },
          {
            value: this.uebersicht.versorgungszielAlter,
            color: BARCOLOR.red,
            text: "Im Alter (" + this.uebersicht.inflationsrate + " % Inflation)",
          }
        ]
      });
      
      this.diagramDataInits.diagrams.push({
        
        title: "Krank&shy;heit",
        bars: [
           {
            value: this.uebersicht.ergVersorgungszielKrankheit.value,
            color: BARCOLOR.blue,  
            text: "Lohn&shy;fort&shy;zahlung (max. " + this.uebersicht.lfzKrankheitsfall + " Tage)"
          },
          {
            value: this.uebersicht.ergKrankengeldKrankheit.value,
            color: BARCOLOR.blue,
            text: "Krank&shy;en&shy;geld (max. 78 Wochen)"
          }
        ]
      });
      
      this.diagramDataInits.diagrams.push({
        
        title: "Berufs&shy;unfähig&shy;keit",
        bars: [
          {
            value: 1111,
            color: BARCOLOR.green,
            text: "bei teil&shy;weiser Er&shy;werbs&shy;min&shy;derung"
          },
          {
            value: 1111,
            color: BARCOLOR.green,
            text: "bei voller Erwerbs&shy;minderung"
          },
        ]
      });
      
      this.diagramDataInits.diagrams.push({
        
        title: "Alters&shy;rente",
        bars: [
          {
            value: 2000,
            color: BARCOLOR.red,
            text: "mit " + this.uebersicht.gewuenschterRentenbeginn + " Jahren"
          }          
        ]
      });
      this.diagramDatas = Object.assign({}, this.diagramDataInits);
    
    }, (error) => {
      alert( error );
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/auswertung/uebersicht/uebersicht.component.ts